/**
 * AdditionalInviteConfirm — logged-in SUB_DELEGATE, email matches (plan §7.3).
 * Confirms adding an additional workspace to the existing account.
 */

import { Link } from 'react-router-dom';
import { InviteSignupShell, InviterBadge } from '@/shared/components/invite-signup';
import type { SubDelegateInvitePublicResponse } from '../types/subDelegateInvite';
import { ownerRoleLabel, permissionLabels } from '../utils/labels';

export type AdditionalInviteConfirmProps = {
  invite: SubDelegateInvitePublicResponse;
  isSubmitting: boolean;
  apiError?: string;
  onAccept: () => void;
};

export const AdditionalInviteConfirm = ({
  invite,
  isSubmitting,
  apiError,
  onAccept,
}: AdditionalInviteConfirmProps) => (
  <InviteSignupShell>
    <InviterBadge
      name={invite.ownerName}
      secondary={ownerRoleLabel(invite.ownerRole)}
      permissions={permissionLabels(invite.permissions)}
    />

    <h2 className="font-recoleta text-white md:w-full text-3xl md:text-4xl">
      Add a new workspace
    </h2>

    <p className="font-termina text-white max-md:text-xl max-md:py-8 py-6">
      <strong>{invite.ownerName}</strong> ({ownerRoleLabel(invite.ownerRole)})
      has invited you to also manage their bQuest workspace.
    </p>

    {apiError && (
      <p className="font-termina text-red-500 font-bold py-4">{apiError}</p>
    )}

    <div className="py-8 gap-4 flex flex-col">
      <button
        type="button"
        onClick={onAccept}
        disabled={isSubmitting}
        className="font-termina bg-[#E2A807] font-black rounded-3xl py-3 px-6 w-max uppercase cursor-pointer hover:bg-[#c99006] active:scale-[0.98] transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#E2A807] disabled:active:scale-100"
      >
        {isSubmitting ? 'Adding Workspace...' : 'Accept Additional Invitation'}
      </button>

      <Link
        to="/dashboard"
        className="font-termina text-white font-bold rounded-3xl py-3 px-6 w-max uppercase border border-white text-center hover:bg-white/10 transition-all duration-150"
      >
        Decline
      </Link>
    </div>
  </InviteSignupShell>
);
